import { render, staticRenderFns } from "./PacketDropdown.vue?vue&type=template&id=8d1a4342&"
import script from "./PacketDropdown.vue?vue&type=script&lang=js&"
export * from "./PacketDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PacketDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports